import get from 'lodash.get';
import actionTypes from '../constants/action-types';

const constraints = (state = [], action) => {
  if (action.type !== actionTypes.SET_CONSTRAINTS) return state;

  return get(action, 'payload.constraints', []);
};

export default constraints;
